// Tag chip colours shared by the puzzle list's tags and the whiteboard's
// cards, so the two stay alike.
export const NEEDS_TAG_COLOR = "#ffc0cb";
export const LOCATION_TAG_COLOR = "#aaffc3";
